import { Component, Input } from '@angular/core';
import { environment } from '@environments/environment';

@Component({
	selector: 'app-icon',
	standalone: true,
	imports: [],
	templateUrl: './icon.component.html',
	styleUrl: './icon.component.css',
})
export class IconComponent {
	environment = environment;
	@Input() name: string = '';
	@Input() url: string = '';
	@Input() innerClass: string = 'icon icon-sm';
	@Input() color: string = 'var(--blue)';
}
